import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { CTASection } from "../components/site/CTASection";
import { RESOURCES, RESOURCE_CATEGORIES } from "../data/resources";

export default function Resources() {
  const [cat, setCat] = useState("All");
  const cats = ["All", ...RESOURCE_CATEGORIES.filter((c) => RESOURCES.some((r) => r.category === c))];
  const list = cat === "All" ? RESOURCES : RESOURCES.filter((r) => r.category === cat);

  return (
    <div>
      <PageHero
        variant="dark"
        label="Resources"
        title="MATRIVON Toolkit"
        intro="Tools worth using — and why. MATRIVON evaluates AI, business software and research tools from a practical business perspective, not a promotional one."
        crumbs={[{ label: "Resources" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <div className="mb-10 grid gap-px border border-brand-line bg-brand-line sm:grid-cols-2 lg:grid-cols-4">
            {["What problem does it solve?", "Who is it genuinely useful for?", "Where does it add value?", "What are its limitations?"].map((q) => (
              <div key={q} className="bg-brand-bg p-6 font-heading text-sm font-semibold text-brand-ink">
                {q}
              </div>
            ))}
          </div>

          <div className="mb-8 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                data-testid={`resource-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`border px-4 py-2 text-sm font-medium transition-colors ${
                  cat === c
                    ? "border-brand-blue bg-brand-blue text-white"
                    : "border-brand-line bg-white text-brand-muted hover:border-brand-blue hover:text-brand-blue"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid gap-px border border-brand-line bg-brand-line md:grid-cols-2 lg:grid-cols-3">
            {list.map((r) => (
              <Link
                key={r.slug}
                to={`/resources/${r.slug}`}
                data-testid={`resource-card-${r.slug}`}
                className="group flex flex-col bg-white p-7 transition-colors hover:bg-brand-blue/[0.03]"
              >
                <span className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-red">{r.category}</span>
                <h3 className="mt-3 font-heading text-lg font-bold text-brand-ink group-hover:text-brand-blue">{r.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-muted">{r.tagline}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue">
                  Read assessment <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>

          <p className="mt-8 text-sm text-brand-muted">
            Some resources may contain affiliate links. Recommendations and assessments remain
            independent of affiliate availability. See our{" "}
            <Link to="/affiliate-disclosure" className="font-semibold text-brand-blue hover:underline">
              Affiliate Disclosure
            </Link>.
          </p>
        </div>
      </section>

      <CTASection primary={{ to: "/insights", label: "Read MATRIVON Insights" }} secondary={{ to: "/contact", label: "Contact MATRIVON" }} />
    </div>
  );
}
